import React from 'react'

export default ({ author_prefix, author, from, from_url, path, date }) => {
  return (
    <span className="blog-post-meta-data">
      {author_prefix ? `${author_prefix} ` : ''}
      <strong>{author}</strong>
      {from ? ' from ' : ''}
      {from ? <a href={from_url}>{from}</a> : ''} on {date}
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/components/BlogPostMetaData.js